import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-47b9db17"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "mail-dialog"
}
const _hoisted_2 = { class: "head g-flex-al-center g-flex-jc-between" }
const _hoisted_3 = { class: "g-f18 g-fw7" }
const _hoisted_4 = { class: "status g-flex-al-center" }
const _hoisted_5 = { class: "QrCode" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "tips" }

import { ElIcon } from "element-plus";
import { Service, CloseBold } from "@element-plus/icons-vue";
import { onMounted, ref } from "vue";
// import { getLarkQR } from "@/api/request/survey";
import serviceIcon from "@/assets/operate/service.png";


export default /*#__PURE__*/_defineComponent({
  __name: 'ContactService',
  setup(__props) {

const isShow = ref(false);
function close() {
  isShow.value = false;
}
function openDialog() {
  if (isShow.value) return;
  isShow.value = true;
}
const QrCodePath = ref(serviceIcon);

onMounted(() => {
  // getLarkQR().then((res) => {
  //   QrCodePath.value = res.data;
  // });
});

return (_ctx: any,_cache: any) => {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (_openBlock(), _createElementBlock("div", {
    class: "contactService",
    tabindex: "-1",
    onBlur: _cache[1] || (_cache[1] = ($event: any) => (close()))
  }, [
    _createVNode(_component_el_tooltip, {
      class: "box-item",
      effect: "dark",
      content: _ctx.$t('官方客服'),
      placement: "left"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: "icon g-flex-jc-center g-flex-al-center g-pointer",
          onClick: openDialog
        }, [
          _createVNode(_unref(ElIcon), { size: "25" }, {
            default: _withCtx(() => [
              _createVNode(_unref(Service))
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["content"]),
    _createVNode(_Transition, null, {
      default: _withCtx(() => [
        (isShow.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t("官方客服")), 1),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", {
                    class: "clear g-flex-al-center g-pointer",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (close()))
                  }, [
                    _createVNode(_unref(ElIcon), { size: "24" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(CloseBold))
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("img", {
                  src: QrCodePath.value,
                  alt: ""
                }, null, 8, _hoisted_6),
                _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t("扫描群二维码,立刻加入该群")), 1)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 32))
}
}

})